// extracted by mini-css-extract-plugin
module.exports = {"adyen-checkout__input":"UnstyledButton_adyen-checkout__input__zg5zW","UnstyledButton":"UnstyledButton_UnstyledButton__1qjqO"};